import { render, staticRenderFns } from "./verifyAccount.vue?vue&type=template&id=3ce00a96&"
import script from "./verifyAccount.vue?vue&type=script&lang=js&"
export * from "./verifyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports